import { render } from "./componentEditExtension.vue?vue&type=template&id=46fc7024"
import script from "./componentEditExtension.vue?vue&type=script&lang=js"
export * from "./componentEditExtension.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__